import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { ImbpBookingInformation } from "@/models/imbpBookingInformation/imbpBookingInformation"
import { ImbpService } from "@/services/ImbpService"
import { AccountService } from "@/services/AccountService"

export const getImbpBookings = (accountNumber: string) => {
  const queries = new QueryAggregator()
  let imbpBookings: ImbpBookingInformation = {} as ImbpBookingInformation

  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)

  queries.add(coreIdQuery)

  if (coreIdQuery.data) {
    const imbpBookingsQuery = ImbpService.getBookingInformation(
      coreIdQuery.data,
    )

    queries.add(imbpBookingsQuery)
    imbpBookings = imbpBookingsQuery.data
  }

  return queries.setData(imbpBookings).getAggregate()
}
